// extracted by mini-css-extract-plugin
export default {"closePreview":"styles_closePreview__j6CIX"};